<script setup>
import { ref, onMounted } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper.js';

defineProps({
  isCollapsed: { type: Boolean, default: false },
});

// 'light' | 'dark' | 'auto'
const mode = ref(LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto');

function applyMode(newMode) {
  mode.value = newMode;
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, newMode);
  const isOSOnDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  setColorTheme(isOSOnDarkMode);
}

function cycleMode() {
  const order = ['light', 'dark', 'auto'];
  const idx = order.indexOf(mode.value);
  applyMode(order[(idx + 1) % order.length]);
}

onMounted(() => {
  // sincroniza estado por si cambió desde otra pestaña/ventana
  mode.value = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
});
</script>

<template>
  <button
    class="flex items-center justify-center rounded-md hover:bg-n-alpha-2 transition text-n-slate-11 hover:text-n-slate-12"
    :class="isCollapsed ? 'w-7 h-7' : 'w-7 h-7'"
    :title="`Tema: ${mode}`"
    @click="cycleMode"
  >
    <span v-if="mode === 'light'" class="i-lucide-sun w-4 h-4" />
    <span v-else-if="mode === 'dark'" class="i-lucide-moon w-4 h-4" />
    <span v-else class="i-lucide-monitor-cog w-4 h-4" />
  </button>
</template>
